import COLORS from './Colors';

export const FONTS = {
  body: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif', 
  heading: '"Bebas Neue", sans-serif',
  roboto: '"Roboto", sans-serif', 
  monospace: 'source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace', 
};

export const FONT_WEIGHTS = {
  normal: 'normal', 
  medium: '500',
  semibold: '600',   
  bold: 'bold',    
};

export const FONT_SIZES = {
  xs: '0.875em',
  sm: '1rem',  
  md: '1.125rem',
  lg: '1.5rem', 
  xl: '1.75rem',
  xxl: '2rem',
  xxxl: '4.5rem',
};

export const SPACING = {
  zero:0,
  xxs: '4px',
  xs: '8px',
  sm: '10px',
  md: '16px',
  lg: '20px',
  xl: '35px', 
  xxl: '40px',

};

export const RADII = {
  sm: '4px',
  md: '8px',
  lg: '10px', 
  xl: '16px',  
  xxl: '20px', 
  round: '50%',
};

export const Z_INDEX = {
  base: 0,
  dropdown: 100,
  sticky: 200,
  modal: 300,
  tooltip: 400,
  notification: 500,
};

export const BREAKPOINTS = {
  sm: '600px',
  md: '768px', 
  lg: '992px', 
  xl: '1200px',
  xxl: '1600px',
  xxxl: '1920px',
  xxxxl: '2560px',
};

export const LAYOUT = {
  pageMaxWidth: '1200px', 
  formMaxWidth: '600px',
  cardMinWidth: '280px',
  cardContentMinWidth: '260px',
};

export const theme = {
  colors: COLORS,
  fonts: FONTS,
  fontWeights: FONT_WEIGHTS,
  fontWeight: FONT_WEIGHTS, // alias for compatibility
  fontSizes: FONT_SIZES,
  fontSize: FONT_SIZES, // alias for compatibility
  spacing: SPACING,
  radii: RADII,
  borderRadius: {
    small: RADII.sm,
    medium: RADII.md,
    large: RADII.lg,
    xlarge: RADII.xl,
    xxlarge: RADII.xxl,
    round: RADII.round,
  },
  breakpoints: BREAKPOINTS,
  layout: LAYOUT,
  zIndex: Z_INDEX,
  maxWidth: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    xxl: '1536px',
  },

  button: {
    height: '48px',            
    borderRadius: RADII.md,
    backgroundColor: COLORS.buttonColor,
    textColor: COLORS.white,
    fontSize: FONT_SIZES.sm,
  },
  header: {
    height: '60px',            
    backgroundColor: COLORS.primary,
    textColor: COLORS.white,
    fontSize: FONT_SIZES.xl,
    paddingHorizontal: SPACING.md,
  },
  modal: {
    contentBackground: COLORS.darkPurple,
    overlayBackground: COLORS.overlayBackground,
    borderRadius: RADII.md,
    padding: `${SPACING.lg} ${SPACING.xxl}`,
  },
  textInput: {
    borderColor: COLORS.inputBorder,
    errorBorderColor: COLORS.inputErrorBorder,
    borderRadius: RADII.md,
    height: '50px',
    padding: SPACING.sm,
  },
  dropdown: {
    borderColor: COLORS.inputBorder,
    errorBorderColor: COLORS.inputErrorBorder,
    borderRadius: RADII.md,
    height: '48px',
  }
};

export type AppTheme = typeof theme;
